import styled, { css } from 'styled-components';
import { pickToken } from '../../forms/styles/helper';
import { ArrowRightIcon } from '../../icon/variants/ui/ArrowRightIcon';
import { pxToRem } from '../../../design-tokens/style-utilities';
const ICON_TRANSFORM = `translateX(${pxToRem(3)});`;
/**
 * LinkBlock
 */
const linkBlockStyles = ({ theme, $colorContext, }) => css `
	padding: ${pxToRem(theme.spacing['300'])} ${pxToRem(theme.spacing['400'])}
		${pxToRem(theme.spacing['300'])} ${pxToRem(theme.spacing['300'])};
	display: flex;
	align-items: center;
	gap: ${pxToRem(theme.spacing['200'])};
	background-color: ${pickToken({
    'on-light': theme.colors.extralight.bgBlocksSecondary,
    'on-medium': theme.colors.blanc.bgCards,
    'on-dark': theme.colors.blanc.bgCards,
}, $colorContext)};
	border-radius: ${pxToRem(theme.borderRadius.m)};
	text-decoration: none;

	&:hover,
	&:active {
		background-color: ${pickToken({
    'on-light': theme.colors.light.bgBlocksSecondaryHover,
    'on-medium': theme.colors.medium.bgBlocksSecondaryHover,
    'on-dark': theme.colors.light.bgBlocksSecondaryHover,
}, $colorContext)};
	}

	&:focus-visible {
		outline-offset: ${theme.borderWidth.m}px;
		outline: ${theme.borderWidth.m}px solid
			${pickToken({
    'on-light': theme.colors.highlight.borderFocus,
    'on-medium': theme.colors.highlight.borderFocus,
    'on-dark': theme.colors.highlight.borderFocusOnDark,
}, $colorContext)};
	}
`;
export const StyledLinkBlock = styled.a `
	${linkBlockStyles}
`;
const linkBlockArrowStyles = ({ theme }) => css `
	flex: none;
	margin-left: auto;
	color: ${theme.colors.highlight.iconInteractive};
	transition: transform ${theme.timing['300']}ms cubic-bezier(${theme.easings.default});

	a:hover &,
	a:focus-visible & {
		transform: ${ICON_TRANSFORM};
	}
`;
export const StyledLinkBlockArrow = styled(ArrowRightIcon).attrs({
    size: 'lg',
}) `
	${linkBlockArrowStyles}
`;
